import './CardListCards.css';
import React from 'react';
import { get, injectImageResolution, getGlobalDictionaryTerm } from '../../../utils';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink';
import ScrollAnimation from 'react-animate-on-scroll';
import { ReactComponent as IconChevronRightLight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../../resources/icons/IconChevronLeftLight.svg';
import { ReactComponent as IconChevronLeftDetLight } from '../../../resources/icons/chevron-left-24-px.svg';
import { ReactComponent as IconChevronRightDetLight } from '../../../resources/icons/chevron-right-24-px.svg';
import LazyPicture from '../../atoms/LazyPicture';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
import { convertToAnalyticObject } from '../../../utils/analytics';
const Cards = _ref => {
  let {
    item,
    params,
    eventsAnalytics
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const cardImageSrc = get(item, 'image.jss.value.src');
  const cardImageAlt = get(item, 'image.jss.value.alt');
  const hasTitle = get(item, 'title.jss.value');
  const hasTag = get(item, 'tag.jss.value');
  const tag = get(item, 'tag.jss');
  const hasDescription = Boolean(get(item, 'description.jss.value'));
  const ctaLabel = get(item, 'ctaLabel.jss.value');
  const ctaLinkHref = get(item, 'ctaLink.jss.value.href');
  const ctaLinktype = get(item, 'ctaLink.jss.value.linktype');
  const cardTitle = get(item, 'title.jss.value');
  const renderContentInLink = children => {
    if (!ctaLinkHref && !pageEditing) return /*#__PURE__*/React.createElement("div", {
      className: "image-wrapper"
    }, children);
    let linkTitle = '';
    if (hasTitle) {
      linkTitle = hasTitle;
    } else {
      linkTitle = cardImageAlt ? cardImageAlt : '';
    }
    if (ctaLabel) {
      linkTitle = `${ctaLabel} | ${linkTitle}`;
    }
    if (item.ctaLink && item.ctaLink.jss && item.ctaLink.jss.value && item.ctaLink.jss.value.target === '_blank') {
      linkTitle = linkTitle ? `${linkTitle} | ${newWindowLabel}` : newWindowLabel;
    }
    return /*#__PURE__*/React.createElement(Link, {
      className: "image-wrapper",
      "aria-label": linkTitle,
      field: item.ctaLink.jss
    }, children);
  };
  const renderLink = () => {
    if (!ctaLabel || !ctaLinkHref) return null;
    if (pageEditing && ctaLinkHref) {
      return /*#__PURE__*/React.createElement(Link, {
        field: item.ctaLink.jss
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "c--link-more"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      isDetSite: isDetSite,
      colorText: `var(--general-card-image-cards-text-color)`,
      color: `var(--general-card-image-cards-color)`,
      href: ctaLinkHref,
      colorActive: `var(--general-card-image-cards-background-active-color)`,
      onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['linkClickAnalytics'], params), [cardTitle, ctaLabel])
    }, ctaLabel && ctaLinkHref ? ctaLabel : null, ctaLabel && ctaLinkHref ? isDetSite ? rtl ? /*#__PURE__*/React.createElement(IconChevronLeftDetLight, null) : /*#__PURE__*/React.createElement(IconChevronRightDetLight, null) : rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null) : null));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
    className: "card-box theme-contrast"
  }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
    },
    useEmptyPlaceholder: true,
    hover: true,
    className: "cardListCardsImage"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    src: `${injectImageResolution(cardImageSrc, 1000, 768)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(cardImageSrc, 800, 615)}`,
    alt: cardImageAlt
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "textContainer"
  }, hasTag && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "b__title",
    field: tag
  }), hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
    }
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  }) : null, renderLink())));
};
const CardListCards = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const title = get(fields, 'data.item.title.jss.value');
  const hasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  const childrenItems = get(fields, 'data.item.children', []);
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const items = childrenItems.length ? childrenItems.filter(item => item.title && item.description) : [];
  const renderItems = () => {
    return items.map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: `itemWidth`,
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1 + index / 3,
      key: index
    }, /*#__PURE__*/React.createElement(Cards, {
      item: item,
      itemsLength: items.length,
      params: params,
      eventsAnalytics: eventsAnalytics,
      title: title
    })));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isDetSite: isDetSite
  }, hasTitle || hasDescription ? /*#__PURE__*/React.createElement("div", {
    className: "h__txt"
  }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "p componentDescription",
    field: fields.data.item.description.jss
  }) : null) : null, /*#__PURE__*/React.createElement("div", {
    className: "itemsContainer"
  }, renderItems()));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    className,
    style,
    isDetSite
  } = _ref3;
  const commonStyles = isDetSite ? "ctq9kta" : "c14hw1h6";
  const ltrStyles = isDetSite ? "l1pyp86w" : "l3v8wu2";
  const rtlStyles = isDetSite ? "r1a7mn20" : "r1bkvv9a";
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
export { CardListCards };